var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenPerp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1109_3427)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7597 9.93528C14.6912 14.221 10.3505 16.8293 6.06422 15.7605C1.77972 14.692 -0.82853 10.351 0.24047 6.06553C1.30847 1.77928 5.64922 -0.829223 9.93422 0.239277C14.2202 1.30778 16.8282 5.64928 15.7597 9.93528Z",
    fill: "#3CEAAA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9055 4.42202C7.40144 3.9394 6.59504 3.9394 6.09097 4.42202L3.88924 6.53007C3.37025 7.02697 3.37026 7.84364 3.88924 8.34054L7.47717 11.7758C7.48165 11.7805 7.48622 11.7852 7.49086 11.7899C7.6317 11.9307 7.81811 12.0013 8.00462 12.0012C8.1921 12.0017 8.37961 11.9311 8.52116 11.7899C8.53225 11.7788 8.54289 11.7675 8.55308 11.7559L12.1117 8.34054C12.6294 7.84364 12.6294 7.02697 12.1117 6.53007L10.9212 5.3875C10.4184 4.90488 9.61388 4.90488 9.11103 5.3875L9.01251 5.48192L7.9055 4.42202ZM9.03346 7.43766C9.36221 7.1229 9.68776 6.80498 10.0161 6.48983L11.0012 7.4353L10.0161 8.38077L9.03346 7.43766ZM7.98372 6.46791L5.98985 8.38077L5.00236 7.43531L6.99824 5.52435L7.98372 6.46791ZM8.00755 8.41992L8.98929 9.36627L8.0054 10.3106L7.01914 9.36627L8.00755 8.41992Z",
    fill: "#141319"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1109_3427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenPerp);
export default __webpack_public_path__ + "static/media/token-perp.d2874c2d1d89e605518cc4fb99c88691.svg";
export { ForwardRef as ReactComponent };